import { legalVictories } from '../data';
import { Trophy, ChevronRight } from 'lucide-react';

export default function LiveTicker() {
  const items = [...legalVictories, ...legalVictories];

  return (
    <section className="py-6 bg-gradient-to-r from-[#0a1628] via-[#0f2240] to-[#0a1628] border-y border-[#c9a84c]/10 overflow-hidden">
      <div className="flex items-center">
        <div className="flex items-center gap-2 px-6 shrink-0 border-r border-[#c9a84c]/20">
          <div className="w-2 h-2 bg-[#c9a84c] rounded-full pulse-dot" />
          <span className="text-xs font-bold text-[#c9a84c] uppercase tracking-widest whitespace-nowrap">Recent Victories</span>
        </div>
        <div className="overflow-hidden flex-1">
          <div className="ticker-animate flex items-center whitespace-nowrap">
            {items.map((item, idx) => (
              <div key={`${item.id}-${idx}`} className="flex items-center shrink-0 px-8">
                <Trophy className="w-4 h-4 text-[#c9a84c] mr-3 shrink-0" />
                <span className="text-sm text-[#e8e4dc]/80">
                  <span className="text-[#c9a84c] font-semibold">{item.result}</span>
                  {' — '}
                  {item.title}
                </span>
                <ChevronRight className="w-4 h-4 text-[#c9a84c]/30 ml-6" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
